/*
 * @Descripttion: 
 * @version: 
 * @Author: jinfjk
 * @Date: 2020-08-17 09:56:43
 * @LastEditors: bbq
 * @LastEditTime: 2020-09-28 15:34:56
 */
const FORM_BROWSE = 'browse';
/**
 * @desc 如果以下条件只要有一个不满足就停止执行下面的代码
 * @param props {object}
 * @param autoFocusDeferred {boolean} true -> 不执行， false -> 执行
 * @param status {string} 此状态是form内部的状态，如果此状态不为空优先读取此状态
 * @returns {boolean}
 */
function stopFormHotKeyChange({ props, autoFocusDeferred, status }) {
    let { name } = props;
    let { withHotKeyChange, meta } = props.getHotKeyConfig ? props.getHotKeyConfig() : {};

    if (!props.getHotKeyConfig) {
        return console.warn('some form hotkey invalid');
    }

    let moduleType = meta[name] &&
        meta[name]['moduletype'];

    let formStatus;
    if (status) {
        formStatus = status;
    } else {
        //首先判断meta中是否存在name ？ (如果有就去取meta里的值，如果meta里没有设置status默认设值浏览态) ：（meta中不存在name默认设值浏览态）
        formStatus = meta[name] ? meta[name].status || FORM_BROWSE : FORM_BROWSE;
    }

    if (name === undefined || withHotKeyChange === false || moduleType === undefined || autoFocusDeferred || formStatus === FORM_BROWSE) {
        return true;
    }

    return false;
}

function stopCardTableHotKeyChange(props) {
    let { name, high_hotkey, getHotKeyConfig } = props;
    // console.log(high_hotkey, getHotKeyConfig)
    let { withHotKeyChange, meta } = props.getHotKeyConfig ? props.getHotKeyConfig() : {};
    if (!props.getHotKeyConfig) {
        return console.warn('some form hotkey invalid');
    }
    let { store, tableId } = high_hotkey;
    if (!store) return true;

    let notEditStatus = store.getTableProps('status') !== 'edit';
    let rows = store.getData();
    let columns = meta[name] && meta[name].items;

    rows = rows === undefined ? [] : rows;

    //状态不是编辑状态，无rows数据, 业务组设置withHotKeyChange->false时停止生成keyMap
    return (notEditStatus || rows.length === 0 || !withHotKeyChange || columns === undefined);
}

function stopEditTableHotKeyChange(props, autoFocusDeferred) {
    let { name, high_hotkey, getHotKeyConfig } = props;
    // console.log(high_hotkey, getHotKeyConfig)
    let { withHotKeyChange, meta } = props.getHotKeyConfig ? props.getHotKeyConfig() : {};
    if (!props.getHotKeyConfig) {
        return console.warn('some form hotkey invalid');
    }
    let { store, tableId } = high_hotkey;
    if (!store) return true;

    let notEditStatus = store.getTableProps('status') !== 'edit';
    let rows = store.getData();
    let columns = meta[name] && meta[name].items;

    rows = rows === undefined ? [] : rows;

    //autoFocusDeferred == true || 状态不是编辑状态，rows无数据 并且业务组设置withHotKeyChange->false时才停止生成keyMap
    return (autoFocusDeferred || notEditStatus || rows.length === 0 || !withHotKeyChange || columns === undefined);

}

export {
    stopFormHotKeyChange,
    stopCardTableHotKeyChange,
    stopEditTableHotKeyChange,
};
